import IconItem from './icon_item';

export default class Import extends IconItem {
  constructor() {
    super('import');
  }
}
